export default "__VITE_ASSET__BbW0_FyN__"